import React, { FC } from 'react';
import { types } from '@polymathnetwork/new-shared';
import { Box } from '~/components/Box';
import { IconCircled } from '~/components/IconCircled';
import { Heading } from '~/components/Heading';
import { CardPrimary } from '~/components/CardPrimary';
import { Paragraph } from '~/components/Paragraph';
import {
  getTransactionIcon,
  getTransactionContent,
} from '~/components/utils/contentMappings';

import * as sc from './styles';

interface TransactionItemProps {
  transaction: types.TransactionPojo;
  getContent: (
    transaction: types.TransactionPojo,
    index: number,
    transactions: types.TransactionPojo[]
  ) => {
    title: string;
    description: string;
  };
  index: number;
  allTransactions: types.TransactionPojo[];
}

interface StaticProps {
  defaultProps: { getContent: TransactionItemProps['getContent'] };
}

export const TransactionItem: FC<TransactionItemProps> & StaticProps = ({
  transaction,
  getContent,
  index,
  allTransactions,
}: TransactionItemProps) => {
  const { title, description } = getContent(
    transaction,
    index,
    allTransactions
  );
  const Icon = getTransactionIcon(transaction);
  return (
    <sc.Wrapper alignItems="flex-start">
      <Box minWidth={50} mt={1}>
        <IconCircled
          Asset={Icon}
          color="white"
          bg="secondary"
          width={32}
          height={32}
          scale={0.8}
        />
      </Box>
      <sc.Info>
        <Heading as="h3" variant="h3" fontSize={2} lineHeight="tight" mb="s">
          {title}
        </Heading>
        <CardPrimary>
          <Paragraph fontSize={4}>{description}</Paragraph>
        </CardPrimary>
      </sc.Info>
    </sc.Wrapper>
  );
};

TransactionItem.defaultProps = {
  getContent: getTransactionContent,
};
try {
    // @ts-ignore
    TransactionItem.displayName = "TransactionItem";
    // @ts-ignore
    TransactionItem.__docgenInfo = { "description": "", "displayName": "TransactionItem", "props": { "transaction": { "defaultValue": null, "description": "", "name": "transaction", "required": true, "type": { "name": "TransactionPojo" } }, "getContent": { "defaultValue": null, "description": "", "name": "getContent", "required": true, "type": { "name": "(transaction: TransactionPojo, index: number, transactions: TransactionPojo[]) => { title: string; description: string; }" } }, "index": { "defaultValue": null, "description": "", "name": "index", "required": true, "type": { "name": "number" } }, "allTransactions": { "defaultValue": null, "description": "", "name": "allTransactions", "required": true, "type": { "name": "TransactionPojo[]" } } } };
    // @ts-ignore
    if (typeof STORYBOOK_REACT_CLASSES !== "undefined")
        // @ts-ignore
        STORYBOOK_REACT_CLASSES["src/components/ModalConfirmTransactionQueue/TransactionItem/index.tsx#TransactionItem"] = { docgenInfo: TransactionItem.__docgenInfo, name: "TransactionItem", path: "src/components/ModalConfirmTransactionQueue/TransactionItem/index.tsx#TransactionItem" };
}
catch (__react_docgen_typescript_loader_error) { }